import { useEffect } from 'react'
import { create } from 'zustand'

/**
 * The active step's chrome — title + a short subtitle — shown in the topbar. This reclaims the
 * space the static brand tagline used AND lets each screen drop its body header (title + lead),
 * so the guidance lives once, in the sticky chrome. Keep subtitles short: the topbar shares its
 * row with the stepper, so long text truncates.
 */
interface PageChromeState {
  title: string
  subtitle: string
  set: (title: string, subtitle: string) => void
}

export const usePageTitleStore = create<PageChromeState>((set) => ({
  title: '',
  subtitle: '',
  set: (title, subtitle) => set({ title, subtitle }),
}))

/** Set the topbar title (and optional subtitle) for the current step. */
export function useSetPageTitle(title: string, subtitle = ''): void {
  const set = usePageTitleStore((s) => s.set)
  useEffect(() => {
    set(title, subtitle)
  }, [title, subtitle, set])
}
